import React from 'react';
import '../Styles/Contact_Bg.css';
import contactBannerImg from '../../Asserts/contact.png';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const Contact_Bg = () => {
  return (
    <div className="contact-hero-wrapper">
      {/* HERO BANNER */}
      <div
        className="cbg-banner-container"
        style={{ backgroundImage: `url(${contactBannerImg})` }}
      >
        <div className="cbg-overlay"></div>
        <div className="cbg-content">
          <h1>Contact Us</h1>
          <p className="cbg-text">
            We'd love to hear from you! Whether you have a question, feedback, or need
            assistance, our team is here to help.
          </p>
        </div>
      </div>

      {/* CONTACT INFO CARDS */}
      <div className="contact-info-strip">
        <div className="contact-info-card">
          <div className="info-icon"><FaMapMarkerAlt /></div>
          <h4>Our Office</h4>
          <p>Chennai, Tamil Nadu, India</p>
        </div>
        <div className="contact-info-card">
          <div className="info-icon"><FaPhoneAlt /></div>
          <h4>Call Us</h4>
          <p>+91 72003 19392</p>
        </div>
        <div className="contact-info-card">
          <div className="info-icon"><FaEnvelope /></div>
          <h4>Email Us</h4>
          <p>info@shantigroup.com</p>
        </div>
      </div>
    </div>
  );
};

export default Contact_Bg;
